import React from "react";

// Colored placeholder block with product name (real images supplied later via admin).
export const ProductImage = ({ product, className = "", big = false }) => {
  const primary = product.image_url || (product.images && product.images[0]) || "";
  if (primary) {
    return (
      <img
        src={primary}
        alt={product.name}
        className={`h-full w-full object-cover ${className}`}
      />
    );
  }
  const color = product.placeholder_color || "#C84B31";
  return (
    <div
      className={`flex h-full w-full flex-col items-center justify-center p-3 text-center ${className}`}
      style={{
        background: `linear-gradient(145deg, ${color}, ${color}cc)`,
        boxShadow: "inset 0 0 40px rgba(0,0,0,0.25)",
      }}
    >
      <span
        className={`font-signboard font-bold leading-tight text-white drop-shadow-md ${
          big ? "text-2xl sm:text-3xl" : "text-sm"
        }`}
      >
        {product.name}
      </span>
      {big && (
        <span className="mt-2 text-[10px] uppercase tracking-widest text-white/70">
          Placeholder art
        </span>
      )}
    </div>
  );
};
